import React from "react";
import { ValimateConstraint, ValimateStep } from "../../autogenerated/models";
import Table from "../Table";
import TruncatedString from "../TruncatedString";

interface StepResultTableProps {
  step: ValimateStep;
  configurationId: string;
}

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (value: string) => (
      <TruncatedString stringValue={value} maxLength={100}></TruncatedString>
    ),
  },
  {
    title: "Severity",
    dataIndex: "severity",
    key: "severity",
  },
  {
    title: "Count",
    dataIndex: "count",
    key: "count",
  },
  {
    title: "Message",
    dataIndex: "message",
    key: "message",
  },
  {
    title: "Model Index",
    dataIndex: "modelIndex",
    key: "modelIndex",
  },
  {
    title: "Step Index",
    dataIndex: "valStepIndex",
    key: "valStepIndex",
  },
];

const StepResultTable: React.FC<StepResultTableProps> = ({
  step = {},
  configurationId = "",
}) => {
  let lastIndex = 0;
  const updateIndex = () => {
    lastIndex++;
    return lastIndex;
  };

  return (
    <Table
      rowKey={(record: ValimateConstraint) =>
        `${updateIndex()}-${step.stepId}-${configurationId}`
      }
      columns={columns}
      dataSource={step.constraints}
      pagination={false}
    />
  );
};

export default StepResultTable;
